// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9779) return "static/chunks/d2d722bc.96d9c83b9b60764a.js";
	if (chunkId === 2253) return "static/chunks/06bab0c8.6ab37e8f70138595.js";
	if (chunkId === 4008) return "static/chunks/4008.4b8bfb388cc4b207.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 696 ? "1e87141b" : chunkId) + "-" + {"696":"cc54f39b4740b5ab","2040":"086de450b94fec74","2412":"d30b8e226d31f26b","2524":"8c1aedf2c44a2dcf","2558":"da0461937b4bd66c","3149":"e6459159ab1ca489","4247":"9f039d637073eaaf","5119":"01c630ce2f22ffc3","9837":"cd9b93bceb7faabf"}[chunkId] + ".js";
};